import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const SocialMediaAccounts = lazy(() => import('./SocialMediaAccounts'));

/**
 * The Social Media Accounts routes.
 */
const socialMediaAccountsRoutes: FuseRouteItemType[] = [
	{
		path: 'social-media-accounts',
		children: [
			{
				index: true,
				element: <SocialMediaAccounts />
			},
			{
				path: ':accountId',
				element: <SocialMediaAccounts />
			}
		]
	}
];

export default socialMediaAccountsRoutes;
